import React, { useEffect, useRef, useState } from 'react';

/**
 * EuropcarLoginReport: Europcar GA4 üye girişi ölçümü — login olayı yok, hesap sayfası
 * başlığından giriş yapmış ziyaretçi ayrımı, canlı site testi, gereken olaylar.
 * Route: /r/europcar-login (ProtectedRoute allowBrandIds Europcar, sidebar'da YOK, link ile)
 *
 * İçerik statik: 4 Kas 2026 GA4 Data API + Playwright. Yeniden üretmek için:
 *   node src/pages/europcar-login/build.js
 * srcDoc izolasyonu şart — rapor global seçiciler taşıyor.
 */
export default function EuropcarLoginReport() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./europcarLoginHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="Europcar · Üye Girişi Ölçümü"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F6F8FF',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F6F8FF' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
